<!--2023.04.19-->
<!--大胶囊最多展示一个，展示广告状态展示中并且排序数值最大的一个；-->
<!--小胶囊最多展示两个，展示广告状态展示中并且排序数值前两位的广告内容；数值大的在上，数值小的在下，小胶囊无内容，空即可，当大胶囊无广告内容时，小胶囊左右平铺展示，-->
<!--广告位说明：小胶囊广告位编码不变，大胶囊为了保证不同版本的适配，使用新广告位编码：App240418-->
<template>
  <div class="advertisement-large">
    <div v-show="advertisement.id" class="pxindBox">
      <img @click="jumpCourseDetail(1,advertisement)" :src="advertisement.images" alt=""/>
    </div>
    <div v-show="advertLists.length > 0" :style="{width: advertisement.id ? '' : '100%',height: advertisement.id ? '' : 'auto'}" class="advertisement">
      <div
        v-for="(item, index) in advertLists"
        :key="item.id"
      >
        <img
          :src="item.images"
          alt=""
          @click="jumpCourseDetail(2,item,index)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {setBaseUrl, gioPlatform, gioJumpType,handleJumpType} from '@/utils/tools';

const pageYear = (window.location.pathname.indexOf('ark/home') !== -1) ? 24 : 23;

export default {
  props: {
    examType: {
      type: Number,
      default: pageYear,
    },
    advertisement: {
      type: Object,
      default: () => ({}),
    },
    advertLists: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      lastTime: null,
      gioType: 1, // 用于埋点 1 点击 2曝光
    };
  },
  components: {},

  created() {
  },

  mounted() {
  },
  watch: {
    advertisement: {
      handler() {
        this.gioEvent(this.advertisement, (this.gioType = 2));
      },
      immediate: true,
      deep: true,
    },
    advertLists: {
      handler() {
        if (!this.advertLists.length) return;
        this.gioEvent(this.advertLists?.[0], (this.gioType = 2));
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 请求弹窗数据
    jumpCourseDetail(type, adInfo, index) {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 1000) return;
      }
      this.gioEvent(adInfo, (this.gioType = 1));
      this.lastTime = Date.now();
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      const pageData = (type === 1) ? this.advertisement : this.advertLists[index];
      handleJumpType(this, pageData);
    },
    gioEvent(item, type) {
      const {title, skipType} = item;
      const adId = item.id;
      if (!adId) return;
      if (type === 1) {
        // 点击广告
        // eslint-disable-next-line
        gio('evar.set', 'capsuleFigure_evar', title);
        // eslint-disable-next-line
        gio('track', 'adClick_event', {
          adPosition_var: `${this.examType ? this.examType : pageYear}考研-首页-胶囊区长图`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: `${this.examType ? this.examType : pageYear}考研-首页-胶囊区长图`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId ? adId.toString() : null, // 广告ID
          adName_var: title || null, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType) || null, // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.advertisement-large {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 40px 0 40px;
}

.pxindBox {
  width: 338px;
  height: 228px;
  margin-bottom: 40px;
  overflow: hidden;
  text-align: center;
  border-radius: 16px;

  img {
    width: 100%;
    height: 100%;
  }
}

.advertisement {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  justify-content: space-between;
  width: 316px;
  height: 228px;
  margin-bottom: 40px;
  div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 316px;
    height: 106px;
    overflow: hidden;
    border-radius: 16px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
